export enum BannersActionTypes {
  FETCH = '@banners/fetch',
  FETCH_STARTED = '@banners/fetch/started',
  FETCH_SUCCEED = '@banners/fetch/succeed',
  FETCH_FAILED = '@banners/fetch/failed',
}
